import React, { useEffect, useState, useRef } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Polyline,
  Popup,
} from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { convertToAMPM } from "../../../utilities";
import { FaBus, FaClock, FaRoute } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { useMap } from "react-leaflet";
import busstop from "../../../Images/busstop.png";
import { getinitialdata } from "../../../services/Trackingservice";
import busdrop from "../../../Images/busdrop1.png";
import buspickup from "../../../Images/bus3.png";
import unknownbus from "../../../Images/busdrop.png";

const pickupIcon = L.divIcon({
  className: "custom-bus-icon pickup",
  iconSize: [35, 35],
  iconAnchor: [17.5, 17.5],
  html: `<img src="${buspickup}" style="width:35px;height:35px;" />`,
});
const dropoffIcon = L.divIcon({
  className: "custom-bus-icon dropoff",
  iconSize: [35, 35],
  iconAnchor: [17.5, 17.5],
  html: `<img src="${busdrop}" style="width:35px;height:35px;" />`,
});
const unknownicon = L.divIcon({
  className: "custom-bus-icon dropoff",
  iconSize: [35, 35],
  iconAnchor: [17.5, 17.5],
  html: `<img src="${unknownbus}" style="width:35px;height:35px;" />`,
});
const Maplocation = () => {
  const navigate = useNavigate();
  const mapRef = useRef();
  const busRefs = useRef({});
  const [route, setRoute] = useState([]);
  const [stop, setStop] = useState([]);
  const [bus, setBus] = useState([]);
  const MapInitializer = ({ onMapReady }) => {
    const map = useMap();

    useEffect(() => {
      if (map) {
        onMapReady(map);
      }
    }, [map]);

    return null;
  };
  const containerStyle = {
    height: "340px",
    width: "100%",
  };
  const getStopIcon = L.icon({
    iconUrl: busstop,
    iconSize: [35, 35],
    iconAnchor: [17, 35],
    shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
    shadowSize: [41, 41],
    shadowAnchor: [13, 41],
  });
  // const animateMarker = (from, to, ref) => {
  //   if (!ref) return;
  //   const duration = 1000;
  //   const start = performance.now();
  //   const step = (now) => {
  //     const progress = Math.min((now - start) / duration, 1);
  //     const lat = from.lat + (to[0] - from.lat) * progress;
  //     const lng = from.lng + (to[1] - from.lng) * progress;
  //     ref.setLatLng([lat, lng]);
  //     if (progress < 1) requestAnimationFrame(step);
  //   };
  //   requestAnimationFrame(step);
  // };
  const animateMarker = (from, to, ref) => {
    return new Promise((resolve) => {
      if (!ref) return resolve();

      const duration = 1000;
      const start = performance.now();

      const step = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        const lat = from.lat + (to[0] - from.lat) * progress;
        const lng = from.lng + (to[1] - from.lng) * progress;
        ref.setLatLng([lat, lng]);
        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          resolve(); // ✅ Animation completed
        }
      };

      requestAnimationFrame(step);
    });
  };
  useEffect(() => {
    getinitialdata({ display_type: "ALL" })
      .then((res) => {
        const data = res.data;
        const route = data?.route_data.map((data) => ({
          id: data?.id,
          polyline: data.polyline,
          stops: data?.stops,
        }));
        setRoute(route);
        const allStops = data?.route_data.flatMap((r) =>
          r.stops.map((s) => ({
            id: s.stop.id,
            name: s.stop.name,
            latitude: parseFloat(s.stop.latitude),
            longitude: parseFloat(s.stop.longitude),
          }))
        );
        setStop(allStops);
        const buses =
          data.bus_data && data.bus_data.length > 0
            ? data.bus_data.map((u) => ({
              route_id: u?.route?.id,
              id: u.bus?.id,
              name: u.bus?.number_plate,
              position:
                u.bus?.latitude != null && u.bus?.longitude != null
                  ? [
                    parseFloat(u.bus?.latitude),
                    parseFloat(u.bus?.longitude),
                  ]
                  : null,
              shift: u?.shift?.name,
              routeName: u.route?.name,
              trip_mode: u.trip_mode,
            }))
            : [];

        setBus(buses);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    const ws = new WebSocket(`${process.env.REACT_APP_WS_URL}/ws/bus-tracking`);
    ws.onopen = () => {
      console.log("✅ WebSocket connected");
      ws.send(JSON.stringify({ action: "subscribe", channel: "BUS_TRACKING" }));
    };

    ws.onmessage = async (event) => {
      const message = JSON.parse(event.data);
      const { event_type, payload } = message;

      if (event_type === "bus_location") {
        const u = payload;
        const busId = u.bus_id;
        const newPos = [
          parseFloat(u?.location.latitude),
          parseFloat(u?.location.longitude),
        ];
        const marker = busRefs.current[busId];
        if (marker && marker.getLatLng) {
          const oldPos = marker.getLatLng();
          await animateMarker(oldPos, newPos, marker);
        }
        setBus((prevBuses) =>
          prevBuses.map((bus) =>
            bus.id === busId ? { ...bus, position: newPos } : bus
          )
        );
      }
    };

    ws.onerror = (err) => {
      console.error("❌ WebSocket error:", err);
    };

    ws.onclose = () => {
      console.log("⚠️ WebSocket closed");
    };
    return () => {
      ws.close();
    };

  }, []);


  const firstLoadRef = useRef(true);
  const [mapInitialized, setMapInitialized] = useState(false);
  useEffect(() => {
    if (!mapInitialized) return;
    const map = mapRef.current;

    if (firstLoadRef.current) {
      firstLoadRef.current = false;

      setTimeout(() => {
        console.log("First load zoom to buses");

        const busCoords = bus
          .filter(
            (bus) =>
              Array.isArray(bus.position) &&
              typeof bus.position[0] === "number" &&
              typeof bus.position[1] === "number"
          )
          .map((bus) => L.latLng(bus.position[0], bus.position[1]));

        if (busCoords.length > 0) {
          const bounds = L.latLngBounds(busCoords);
          if (bounds.isValid()) {
            map.flyToBounds(bounds, { padding: [10, 10], duration: 1 });
          } else {
            console.warn("Bus bounds are invalid.");
            map.setView([20.293, 85.818], 13);
          }
        } else {
          console.warn("No valid bus coordinates found.");
          map.setView([20.293, 85.818], 13);
        }
      }, 0);
    }
  }, [mapInitialized]);
  const busPosition = bus.length ? bus[0].position : [20.2961, 85.8245];
  return (
    <div className="card rounded-3 border" style={{ overflow: "hidden" }}>
      <div className="card-body p-0">
        {bus.length > 0 || route.length > 0 ? (
          <Link to="/tracking/trackmap">
            <MapContainer
              center={busPosition}
              zoom={14}
              style={containerStyle}
              attributionControl={false}
            >
              <MapInitializer
                onMapReady={(mapInstance) => {
                  console.log("MapInitializer fired");
                  mapRef.current = mapInstance;
                  setMapInitialized(true);
                }}
              />
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
              {route.map((item, idx) => (
                <Polyline
                  key={idx}
                  positions={item?.polyline.map(([lon, lat]) => [lat, lon])}
                  color="blue"
                  weight={4}
                />
              ))}
              {stop.map((stop, index) => (
                <Marker
                  key={`stop_${index}`}
                  position={[stop.latitude, stop.longitude]}
                  icon={getStopIcon}
                >
                  <Popup>
                    <span className="fw-semibold">{stop.name}</span>
                  </Popup>
                </Marker>
              ))}
              {bus.map((bus) => (
                <Marker
                  key={bus.id}
                  position={bus.position}
                  icon={
                    bus.trip_mode === "PICKUP"
                      ? pickupIcon
                      : bus.trip_mode == "DROP"
                        ? dropoffIcon
                        : unknownicon
                  }
                  ref={(ref) => {
                    if (ref) busRefs.current[bus.id] = ref;
                  }}
                >
                  <Popup>
                    <div className="popup-content">
                      <div className="popup-header">
                        <FaBus className="popup-icon me-1" />
                        <b className="text-primary">{bus.name}</b>
                        <span
                          className={`ms-2 badge text-bg-${bus.delay === "0s" ? "success-soft" : "danger-soft"
                            }`}
                        >
                          {bus.delay === "0s"
                            ? "On Time"
                            : `Delay: ${bus.delay}`}
                        </span>
                      </div>
                      <div className="popup-details">
                        <FaRoute className="popup-icon me-1" />
                        <span>
                          {bus.routeName} ({bus.shift})
                        </span>
                      </div>
                      {bus.arrival && bus.estimatearrival && (
                        <>
                          <div className="popup-details">
                            <FaClock className="popup-icon me-1" />
                            Schedule Arrival:
                            <span className="badge text-bg-info-soft">
                              {convertToAMPM(bus.arrival)}
                            </span>
                          </div>
                          <div className="popup-details mt-1">
                            <FaClock className="popup-icon me-1" />
                            Estimated Arrival:
                            <span className="badge text-bg-warning-soft">
                              {convertToAMPM(bus.estimatearrival)}
                            </span>
                          </div>
                        </>
                      )}
                    </div>
                  </Popup>
                </Marker>
              ))}
            </MapContainer>
          </Link>
        ) : (
          <div className="d-flex justify-content-center align-items-center p-3">
            <span>No Data Found</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default Maplocation;
